<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Customer from '@/components/widgets/customer'
import CustomerService from '@/services/customer'

export default {
  page: {
    title: "Clientes",
  },
  components: { Layout, PageHeader, Customer },
  data() {
    return {
      title: "Clientes",
      loading: false,
      customers: [],
      
      searchValue: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      showModal: false,
      searchEmptyField: false,
    }
  },
  computed: {
    rows() {
      return this.customers.length;
    }
  },
  methods: {
    loadCustomers(showLoading = true, page = 1, term = '') {
      if (showLoading) {
        this.loading = true;
      }

      CustomerService.getAll(page, term)
        .then(res => {
          this.loading = false;

          this.customers = res.data.customers;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCustomers(true, this.currentPage);
    },
    search() {
      this.searchEmptyField = false,
      this.loadCustomers(true, 1, this.searchValue);
    },
    changeSearch() {
      if (this.searchValue === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCustomers(true, 1, this.searchValue);
      }
    }
  },
  mounted() {
    this.loadCustomers();
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2 align-items-center">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="mr-2 mb-2">
                  <div class="position-relative search-input">
                    <form @submit.prevent="search" class="align-items-center">
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchValue"
                        v-on:keyup="changeSearch"
                        placeholder="Razão social, Fantasia, código ou CNPJ..."
                      />

                      <button type="submit" class="btn btn-primary" v-if="!loading">
                        Pesquisar
                      </button>

                      <a href="javascript:void(0);" class="text-primary" v-if="loading">
                        <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                      </a>
                    </form>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>

            <div v-if="customers && customers.length > 0">
              <!-- Table data -->
              <Customer :customers="customers" :loadCustomers="this.loadCustomers" :action="$route.query.action"/>

              <div class="row justify-content-md-between align-items-md-center mt-4">
                <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
                <!-- end col-->
                <div class="col-xl-5">
                  <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                    <b-pagination
                      v-model="currentPage" 
                      :total-rows="count"
                      :per-page="perPage"
                      @input="onPageChange"
                    ></b-pagination>
                  </div>
                </div>
                <!-- end col-->
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-primary">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </a>
        </div>
      </div>
    </div> -->
  </Layout>
</template>

<style lang="scss">
  .search-input form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }
</style>